import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("option", { value: "plus" }, "+", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "minus" }, "−", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "times" }, "×", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "divide by" }, "÷", -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers($setup.onSubmit, ["prevent"]),
    id: "keypad"
  }, [
    _withDirectives(_createElementVNode("input", {
      maxlength: "10",
      id: "a",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.a) = $event))
    }, null, 512 /* NEED_PATCH */), [
      [_vModelText, $setup.a]
    ]),
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.operator) = $event))
    }, _hoisted_5, 512 /* NEED_PATCH */), [
      [_vModelSelect, $setup.operator]
    ]),
    _withDirectives(_createElementVNode("input", {
      maxlength: "10",
      id: "b",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.b) = $event))
    }, null, 512 /* NEED_PATCH */), [
      [_vModelText, $setup.b]
    ]),
    _createElementVNode("input", {
      value: "Execute",
      type: "submit",
      disabled: $setup.is_running
    }, null, 8 /* PROPS */, _hoisted_6)
  ], 32 /* NEED_HYDRATION */))
}